import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { fileURL, numPages } = state || {};

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    if (!email.trim() || !password.trim()) {
      setError('Por favor, ingresa un email y una contraseña.');
      return;
    }

    setLoading(true);

    try {
      console.log('Intentando iniciar sesión con:', { email });

      const response = await fetch('https://h6w6xu1r59.execute-api.us-east-1.amazonaws.com/first/cognito_access', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password }),
      });

      const result = await response.json();

      if (response.ok && result.idToken && result.accessToken) {
        console.log('Inicio de sesión exitoso:', email);

        // Imprimir tokens en consola
        //console.log('ID Token:', result.idToken);
        //console.log('Access Token:', result.accessToken);

        // Guardar tokens en Cookies y localStorage
        Cookies.set('idToken', result.idToken, { secure: true, sameSite: 'Strict', expires: 7 });
        localStorage.setItem('idToken', result.idToken);

        Cookies.set('accessToken', result.accessToken, { secure: true, sameSite: 'Strict', expires: 7 });
        localStorage.setItem('accessToken', result.accessToken);

        // Redirigir al usuario
        const redirectState = fileURL
          ? { idToken: result.idToken, accessToken: result.accessToken, fileURL, numPages }
          : { idToken: result.idToken, accessToken: result.accessToken, email };

        navigate('/PaymentGateway', { state: redirectState });
      } else {
        setError(result.message || 'Error al autenticar. Verifica tus credenciales.');
      }
    } catch (err) {
      console.error('Error durante el login:', err);
      setError('Ocurrió un error. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h2>Log In</h2>
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="button" disabled={loading}>
          {loading ? 'Cargando...' : 'Iniciar Sesión'}
        </button>
      </form>
      {error && <p className="error-message">{error}</p>}
      <p>
        ¿No tienes una cuenta? <Link to="/register">Regístrate aquí</Link>
      </p>
      <p>
        <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
      </p>
    </div>
  );
}

export default Login;
